export default __webpack_public_path__ + "static/media/IMG_2759.9b497ac3.jpg";